export abstract class LanguageFactory {
  abstract setLang(language: string): void;
}
